module.exports = __webpack_public_path__ + "img/Hand-p-1080.f501ad28.png";